import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  VDM,
  ListVDMsInput,
  ListVDMsResponse,
  GetVDMResponse,
} from '@erp/rpc';

export function useVDMsList(filters: ListVDMsInput = {}) {
  const query = useQuery(
    orpc.shipAndDebit.vdms.list.queryOptions({
      input: filters,
    }),
  );

  const vdms = query.data?.vdms ?? [];
  const pagination = query.data?.pagination;

  return {
    ...query,
    vdms,
    pagination,
  } satisfies typeof query & {
    data?: ListVDMsResponse;
    vdms: VDM[];
    pagination: ListVDMsResponse['pagination'] | undefined;
  };
}

export function useVDM(id: string | undefined, enabled = true) {
  const query = useQuery({
    ...orpc.shipAndDebit.vdms.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id) && enabled,
  });

  return {
    ...query,
    vdm: query.data ?? null,
  } satisfies typeof query & {
    data?: GetVDMResponse;
    vdm: GetVDMResponse | null;
  };
}
